import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text } from '@ui-kitten/components';
import { StyleSheet, ScrollView, View, Dimensions } from 'react-native';
import {AgentInfo} from './agentInfo.js'
import {CustomerInfo} from './customerInfo.js'
import {ServiceInfo} from './serviceInfo.js'
import {TopBar} from './topBar.js'
import { useSelector, useDispatch} from 'react-redux';
import { saveNewAddress } from '../../../store/actions/newAddress'
import trackerApi from '../../api/tracker';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { showMessage, hideMessage } from "react-native-flash-message";
import * as RootNavigation from '../../../root.navigation.js';

//
const width = Dimensions.get('window').width-30

export const SaveButton =  () => {
    const merchant_phone =  useSelector( state => state.newAddress.merchant_phone);
    const merchant_address = useSelector( state => state.newAddress.merchant_address);
    const merchant_name= useSelector( state => state.newAddress.merchant_name);
    const problem=useSelector( state => state.newAddress.problem);
    const product_model=useSelector( state => state.newAddress.product_model);
    const product_category=useSelector( state => state.newAddress.product_category);
    const service_type=useSelector( state => state.newAddress.service_type);
    const merchant_province=useSelector( state => state.newAddress.merchant_province);
    const merchant_city=useSelector( state => state.newAddress.merchant_city);
    const maqaze =useSelector( state => state.newAddress.dareMaqaze);
    const state =useSelector( state => state.newAddress);
    const [saveDisable, setSaveDisable] = useState(false)
    const dispatch = useDispatch();
  const saveAddress = async()=>{
    // dispatch(saveNewAddress(true))
    setSaveDisable(true)
    const token =  await AsyncStorage.getItem('userId');
    const addressInfo ={
      merchant_phone,
      merchant_address,
      merchant_name,
      problem,
      product_model,
      product_category,
      service_type,
      merchant_province,
      merchant_city,
      maqaze
    }
    console.log(addressInfo);

    if(
      merchant_phone.length<8
    ){
      showMessage({
        message: 'لطفا شماره تلفن را درست وارد نمایید.',
        type: "danger",
      });
      setSaveDisable(false)
    } else if(
      merchant_address.length<3
    ){
      showMessage({
        message: 'لطفاآدرس را درست وارد نمایید.',
        type: "danger",
      });
      setSaveDisable(false)
    }
    else if(
      merchant_name.length<2
    ){
      showMessage({
        message: 'لطفا نام مشتری را درست وارد نمایید.',
        type: "danger",
      });
      setSaveDisable(false)

    }
    else if(
      problem.length<3
    ){
      showMessage({
        message: 'لطفا مشکل دستگاه را درست وارد نمایید.',
        type: "danger",
      });
      setSaveDisable(false)

    }
    else if(
      product_model.length<2
    ){
      showMessage({
        message: 'لطفا مدل دستگاه را درست وارد نمایید.',
        type: "danger",
      });
      setSaveDisable(false)

    }
    else if(
      product_category.length<2
    ){
      showMessage({
        message: 'لطفا دسته بندی را درست وارد نمایید.',
        type: "danger",
      });
      setSaveDisable(false)

    }

    else if(
      service_type.length<2
    ){
      showMessage({
        message: 'لطفا نوع سرویس را درست وارد نمایید.',
        type: "danger",
      });
      setSaveDisable(false)

    }
    else if(
      merchant_province.length<2
    ){
      showMessage({
        message: 'لطفا استان را درست وارد نمایید.',
        type: "danger",
      });
      setSaveDisable(false)

    }
    else if(
      merchant_city.length<1
    ){
      showMessage({
        message: 'لطفا شهر را درست وارد نمایید.',
        type: "danger",
      });
      setSaveDisable(false)

    }
    else{
    const response = await trackerApi.post('/address/addAddressV2', addressInfo, {
      headers: {Authorization: `Bearer ${token}`}
    });

    if(response.data.status) {
      console.log(response.data.status)
      showMessage({
        message: 'اطلاعات با موفقیت ثبت شد',
        type: "success",
      });
      RootNavigation.navigate('Menu')
    }
    else {
      console.log(response.data.error)
      showMessage({
        message: response.data.error,
        type: "danger",
      });
      setSaveDisable(false)
    };
  }
  }

  return (
      <View style={styles.container} >
        <Button appearance='outline' style={{flex:1,borderRadius:10, marginHorizontal:5}} onPress= {()=>RootNavigation.navigate('Menu')}> بازگشت</Button>
        <Button style={{flex:2, borderRadius:10,  marginHorizontal:5}} disabled={saveDisable} onPress= {saveAddress}> ثبت اطلاعات</Button>
      </View>

  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
    flexDirection:'row',
    width,
    justifyContent:'space-between',
    margin:10
  },
});
